module.exports = __webpack_public_path__ + "static/media/ag-courtney-coverBOOK2.38a525ff.jpg";